<template>
  <div name="modal">
    <div id="modal_pool" class="modal_mask" @click="closeModalPool()"></div>
    <div class="modal_wrapper">
      <div class="modal_container">
        <div class="modal_header">
          {{ $tc("msg.modal_pool_title", 1) }}

          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
            @click="closeModalPool()"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>

        <div class="modal_content" v-if="firstScreenModal">
          <h3 v-html="$t('msg.modal_pool_text')"></h3>

          <p>{{ $tc("msg.modal_pool_text2", 1) }}</p>

          <span
            ><strong>{{ $tc("msg.modal_pool_important", 1) }}:</strong>
            {{ $tc("msg.modal_pool_text3", 1) }}</span
          >

          <div class="wrapper_action_modal">
            <label for="nickname">{{ $tc("msg.modal_pool_nick", 1) }}</label>
            <input id="nickname" type="text" v-model="nickname" />
            <span>
              {{ $tc("msg.modal_pool_nick_span", 1) }}
            </span>

            <label>{{ $tc("msg.modal_pool_avatar", 1) }}</label>
            <div class="select_avatar">
              <div
                class="icons"
                v-for="(icon, index) in icons"
                :key="index"
                @click="selectedAvatar = index"
                :style="selectedAvatar === index ? selectedAvatarStyle : null"
              >
                <img :src="icon" alt="avatar" />
              </div>
            </div>

            <button class="button_join" @click="joinPoolAction()">
              {{ $tc("msg.modal_pool_btn", 1) }}
            </button>
          </div>
        </div>

        <div class="modal_content" v-else>
          <div class="content_welcome">
            <h3 class="welcome">{{ $tc("msg.modal_pool_welcome", 1) }}</h3>
            <div class="avatar_icon">
              <span>{{ memberRespPoolConfirm.nickname }}</span>
              <img
                :src="renderImage(memberRespPoolConfirm.avatar)"
                :alt="memberRespPoolConfirm.avatar"
              />
            </div>

            <p>
              {{ $tc("msg.modal_pool_span", 1) }}
            </p>
            <p>{{ $tc("msg.modal_pool_span2", 1) }}</p>

            <div class="action_close">
              <div class="copy_link" style="display:flex; align-items:flex-end">
                <span
                  >{{ $tc("msg.modal_pool_referral", 1) }}
                  {{ member.referCode }}</span
                >

                <button
                  type="button"
                  v-clipboard:copy="member.referCode"
                  v-clipboard:success="onCopySuccess"
                  v-clipboard:error="onCopyError"
                >
                  {{ $tc("msg.copy", 1) }}
                </button>
              </div>

              <p>{{ $tc("msg.modal_pool_referral_link", 1) }}:</p>
              <div class="copy_link">
                <a
                  :href="`https://bluetoken.io/app/referralcode=${member.referCode}`"
                  target="_blank"
                  >https://bluetoken.io/app/referralcode={{
                    member.referCode
                  }}</a
                >
                <button
                  type="button"
                  v-clipboard:copy="
                    `https://bluetoken.io/app/referralcode=${member.referCode}`
                  "
                  v-clipboard:success="onCopySuccess"
                  v-clipboard:error="onCopyError"
                >
                  {{ $tc("msg.copy", 1) }}
                </button>
              </div>

              <button class="button_join" @click="closeModalPool()">
                {{ $tc("msg.modal_pool_close", 1) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import avatar1 from "../../assets/images/Avatar-Blue-Pool/avatar1.svg";
import avatar2 from "../../assets/images/Avatar-Blue-Pool/avatar2.svg";
import avatar3 from "../../assets/images/Avatar-Blue-Pool/avatar3.svg";
import avatar4 from "../../assets/images/Avatar-Blue-Pool/avatar4.svg";
import avatar5 from "../../assets/images/Avatar-Blue-Pool/avatar5.svg";
import avatar6 from "../../assets/images/Avatar-Blue-Pool/avatar6.svg";
import avatar7 from "../../assets/images/Avatar-Blue-Pool/avatar7.svg";
import avatar8 from "../../assets/images/Avatar-Blue-Pool/avatar8.svg";
import avatar9 from "../../assets/images/Avatar-Blue-Pool/avatar9.svg";
import avatar10 from "../../assets/images/Avatar-Blue-Pool/avatar10.svg";

import Swal from "sweetalert2";

export default {
  created() {
    this.getMember();
  },
  data: () => ({
    icons: [
      avatar1,
      avatar2,
      avatar3,
      avatar4,
      avatar5,
      avatar6,
      avatar7,
      avatar8,
      avatar9,
      avatar10,
    ],
    member: [],
    poolUser: "",
    nickname: "",
    selectedAvatar: "",
    iconToRequest: "",
    firstScreenModal: true,

    memberRespPoolConfirm: "",
  }),
  methods: {
    closeModalPool() {
      this.$emit("closeModalPool");
    },

    async joinPoolAction() {
      let self = this;

      self.iconToRequest = `avatar${self.selectedAvatar}`;

      let backendAvatar = `avatar${self.selectedAvatar + 1}`;

      let params = {
        avatar: backendAvatar,
        nickname: self.nickname,
      };

      console.log(params);

      if (self.nickname !== "" && self.selectedAvatar !== "") {
        await this.$store
          .dispatch("addMemberToPool", params)
          .then(async (resp) => {
            if (resp.status == 200) {
              this.getMember();
              this.getPoolUser();

              self.firstScreenModal = false;

              await this.$store.dispatch("joinPool");
              this.memberRespPoolConfirm = resp.data;
              this.$emit("reloadUser");
            }
          })
          .catch((e) => {
            console.log(e);
            Swal.fire({
              icon: "error",
              title: this.$t("msg.error"),
              text: this.$t("msg.error_pool_avatar"),
            });
          });
      } else {
        Swal.fire({
          icon: "error",
          title: this.$t("msg.error"),
          text: this.$t("msg.error_pool_avatar_select"),
        });
      }
    },

    async getPoolUser() {
      await this.$store.dispatch("getPoolUser").then((resp) => {
        this.poolUser = resp.data;
      });
    },

    async getMember() {
      await this.$store.dispatch("getMember").then((resp) => {
        this.member = resp;
      });
    },

    renderImage(e) {
      if (e == "avatar1") {
        return avatar1;
      } else if (e == "avatar2") {
        return avatar2;
      } else if (e == "avatar3") {
        return avatar3;
      } else if (e == "avatar4") {
        return avatar4;
      } else if (e == "avatar5") {
        return avatar5;
      } else if (e == "avatar6") {
        return avatar6;
      } else if (e == "avatar7") {
        return avatar7;
      } else if (e == "avatar8") {
        return avatar8;
      } else if (e == "avatar9") {
        return avatar9;
      } else if (e == "avatar10") {
        return avatar10;
      }
    },
  },
  computed: {
    selectedAvatarStyle: function () {
      let styleRadarContainerInactive = {
        borderRadius: "2rem",
        border: "2px solid #342365",
      };

      return styleRadarContainerInactive;
    },
    ...mapGetters(["joinPool"]),
  },
  components: {},
};
</script>

<style lang="scss" scope>
.modal_mask {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 998;
  overflow: auto;
}

.modal_wrapper {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  margin: 0px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  width: 100%;

  .modal_container {
    width: 100%;
    max-width: 600px;
    margin: 0px auto;
    background-color: #fff;
    border-radius: 8px;

    .modal_header {
      position: relative;
      background: #342365;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      padding: 1rem 0;
      font-weight: 600;
      letter-spacing: 2px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      text-transform: uppercase;

      svg {
        width: 1.5rem;
        position: absolute;
        right: 1rem;
        cursor: pointer;
      }
    }

    .modal_content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      color: #000;
      padding: 1rem 1.5rem;
      margin-bottom: 1rem;

      h3 {
        text-align: start;
        margin-bottom: 1rem;
        width: 100%;

        a {
          width: 100px;
        }
      }

      .wrapper_action_modal {
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-top: 1rem;
        color: gray;

        label {
          color: #342365;
          font-weight: 600;
        }

        input {
          border-radius: 8px;
          outline: none;
          padding: 0.5rem;
          border: 1px solid #d2d2d2;
        }

        span {
          color: gray;
          font-size: 14px;
          margin-bottom: 2rem;
        }

        .select_avatar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 0.5rem;
          padding: 0 1rem;

          .icons {
            border-radius: 2rem;
            border: 1px solid transparent;

            &:hover {
              opacity: 0.8;
              border: 1px solid #342365;
              border-radius: 2rem;
            }

            img {
              width: 2.5rem;
              cursor: pointer;
            }
          }
        }

        .button_join {
          margin-top: 2rem;
          border: none;
          color: #fff;
          cursor: pointer;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 6px;
          background: #28a191;
          padding: 8px 30px;
          transition: ease-in-out all 0.2s;
          &:hover {
            background: rgba(40, 161, 145, 0.8);
          }
        }
      }

      .content_welcome {
        .welcome {
          font-size: 20px;
          text-align: center;
          color: #4a4a4a;
        }
        .avatar_icon {
          display: flex;
          flex-direction: column;
          align-items: center;

          img {
            padding: 0.5rem 0;
            width: 6rem;
          }

          span {
            font-size: 20px;
            color: #444444;
            font-weight: 600;
          }
        }

        p {
          padding-top: 1rem;
        }

        .action_close {
          display: flex;
          flex-direction: column;

          span {
            margin-top: 2rem;
            color: #342365;
          }

          p {
            // margin-top: 1rem;
            color: #342365;
          }

          .copy_link {
            display: flex;
            align-items: center;

            button {
              margin-top: 0;
              margin-left: 10px;
              padding: 5px 20px;
            }
          }

          button {
            margin-top: 2rem;
            border: none;
            color: #fff;
            cursor: pointer;
            font-size: 1rem;
            font-weight: 600;
            border-radius: 6px;
            background: #28a191;
            padding: 8px 30px;
            transition: ease-in-out all 0.2s;
            &:hover {
              background: rgba(40, 161, 145, 0.8);
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 627px) {
  .modal_wrapper {
    max-width: 450px;

    .modal_container {
      .modal_content {
        padding: 1rem;

        .select_avatar {
          padding: 0 !important;

          .icons {
            img {
              width: 1.5rem !important;
            }
          }
        }
      }
    }

    .copy_link {
      flex-direction: column;
      align-items: flex-start !important;

      button {
        margin-left: 0 !important;
        margin-top: 5px !important;
      }
    }
  }
}

@media only screen and (max-width: 470px) {
  .modal_wrapper {
    max-width: 360px;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/modals/modalPool.vue